import type { PenPickerOption } from '@/components/organisms/FishGroupForms';

import type { SitePen } from './sitePens';

/** `t` of the `fishGroups` namespace. */
export type Translate = (key: string, options?: Record<string, unknown>) => string;

/**
 * The site's pens for a move: only empty pens can be picked (D4: an occupied pen is a merge),
 * the group's own pen and the occupied ones are shown so the site reads as it is.
 */
export function movePenOptions(
    pens: readonly SitePen[],
    currentCageId: number | null,
    t: Translate
): PenPickerOption[] {
    return pens.map((pen) => {
        const current = pen.cageId === currentCageId;
        return {
            cageId: pen.cageId,
            label: pen.displayName,
            detail: current
                ? t('siteActions.form.currentPen')
                : pen.occupant
                  ? pen.occupant.fishGroupName
                  : t('siteActions.form.emptyPen'),
            disabled: current || pen.occupant !== null,
        };
    });
}
